// extracted by mini-css-extract-plugin
export default {"loader":"SpinLoader_loader__xkDC1","rotation":"SpinLoader_rotation__hwZCt","spinLoader":"SpinLoader_spinLoader__FD6Da"};